import AboutModal from './AboutModal.json';
import Buttons from './Buttons.json';
import CineDialog from './CineDialog.json';
import Common from './Common.json';
import DatePicker from './DatePicker.json';
import Header from './Header.json';
import MeasurementTable from './MeasurementTable.json';
import SidePanel from './SidePanel.json';
import StudyBrowser from './StudyBrowser';
import StudyList from './StudyList.json';
import UserPreferencesModal from './UserPreferencesModal.json';
import ViewportDownloadForm from './ViewportDownloadForm.json';
import Report from './Report';
import Vindoc from './Vindoc';
import ViewerTool from './ViewerTool';

export default {
  'en-US': {
    AboutModal,
    Buttons,
    CineDialog,
    Common,
    DatePicker,
    Header,
    MeasurementTable,
    SidePanel,
    StudyBrowser,
    StudyList,
    UserPreferencesModal,
    ViewportDownloadForm,
    Report,
    Vindoc,
    ViewerTool,
  },
};
